import { render, staticRenderFns } from "./SysItemListaSelecionaTudo.vue?vue&type=template&id=42f29427&scoped=true"
import script from "./SysItemListaSelecionaTudo.vue?vue&type=script&lang=js"
export * from "./SysItemListaSelecionaTudo.vue?vue&type=script&lang=js"
import style0 from "./SysItemListaSelecionaTudo.vue?vue&type=style&index=0&id=42f29427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f29427",
  null
  
)

export default component.exports